"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OctopusFeatureContext = void 0;
var core_1 = require("@openfeature/core");
var OctopusFeatureContext = /** @class */ (function () {
    function OctopusFeatureContext(toggles) {
        this.toggles = toggles;
    }
    OctopusFeatureContext.prototype.evaluate = function (slug, defaultValue, context) {
        if (!slug.match(/^([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*)$/g)) {
            return {
                value: defaultValue,
                errorCode: core_1.ErrorCode.FLAG_NOT_FOUND,
                errorMessage: "Flag key provided was not a slug. Please ensure to provide the slug associated with your Octopus Feature Toggle.",
            };
        }
        var evaluation = this.toggles.evaluations.find(function (feature) { return feature.slug.toLowerCase() === slug.toLowerCase(); });
        if (!evaluation) {
            return {
                value: defaultValue,
                errorCode: core_1.ErrorCode.FLAG_NOT_FOUND,
                errorMessage: "The slug provided did not match any of your Octopus Feature Toggles. Please double check your slug and try again.",
            };
        }
        return { value: this.evaluateSegments(evaluation, context) };
    };
    OctopusFeatureContext.prototype.matchesSegment = function (context, segments) {
        if (!context)
            return false;
        // Group segments by key
        var groupedSegments = segments.reduce(function (groups, segment) {
            if (!groups[segment.key]) {
                groups[segment.key] = [];
            }
            groups[segment.key].push(segment.value);
            return groups;
        }, {});
        // Check if all segment groups have at least one matching context entry
        var result = Object.keys(groupedSegments).every(function (segmentKey) {
            var group = groupedSegments[segmentKey];
            return group.some(function (segment) {
                return Object.keys(context).some(function (contextKey) {
                    var contextValue = context[contextKey];
                    if (typeof contextValue === "string") {
                        return contextKey === segmentKey && contextValue === segment;
                    }
                    return false;
                });
            });
        });
        return result;
    };
    OctopusFeatureContext.prototype.evaluateSegments = function (evaluation, context) {
        var result = evaluation.isEnabled && (Object.keys(evaluation.segments).length === 0 || this.matchesSegment(context, evaluation.segments));
        return result;
    };
    return OctopusFeatureContext;
}());
exports.OctopusFeatureContext = OctopusFeatureContext;
